import { IMiscState } from "@monorepo/types";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

const initialState = {} as IMiscState;

const miscSlice = createSlice({
  name: "misc",
  initialState,
  reducers: {
    setMobilePopUp(state, action: PayloadAction<boolean>) {
      return { ...state, mobilePopUp: action.payload };
    },
    setModalOpened(state, action: PayloadAction<boolean>) {
      return { ...state, modalOpened: action.payload };
    },
    setLoggedOutUserModalClosed(state, action: PayloadAction<boolean>) {
      return { ...state, loggedOutUserModalClosed: action.payload };
    },
  },
});

export const { setModalOpened, setMobilePopUp, setLoggedOutUserModalClosed } = miscSlice.actions;
export default miscSlice.reducer;
